import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginComponent} from './pages/login/login.component';
import {RecuperarSenhaComponent} from './pages/recuperar-senha/recuperar-senha.component';
import {RecuperarSenhaVerificacaoComponent} from './pages/recuperar-senha/recuperar-senha-verificacao/recuperar-senha-verificacao.component';
import {SelecionarBeneficiarioComponent} from './pages/selecionar-beneficiario/selecionar-beneficiario.component';
import {SolicitacoesComponent} from './pages/solicitacoes/solicitacoes.component';
import {NovaSolicitacaoComponent} from './pages/solicitacoes/nova-solicitacao/nova-solicitacao.component';
import {SolicitacaoComponent} from './pages/solicitacoes/solicitacao/solicitacao.component';
import {AuthGuard} from './security/auth.guard';

const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: 'login', component: LoginComponent},
  {path: 'recuperar-senha', component: RecuperarSenhaComponent},
  {path: 'recuperar-senha-verificacao', component: RecuperarSenhaVerificacaoComponent},
  {path: 'selecionar-beneficiario', component: SelecionarBeneficiarioComponent, canActivate: [AuthGuard]},
  {path: 'solicitacoes', component: SolicitacoesComponent, canActivate: [AuthGuard]},
  {path: 'solicitacoes/nova-solicitacao', component: NovaSolicitacaoComponent, canActivate: [AuthGuard]},
  {path: 'solicitacoes/solicitacao', component: SolicitacaoComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
